<template>
    <main id="app" class="h-screen w-screen">
        <router-view />
        <footer-app />
        <plan-upgrade-host />
        <legal-acceptance-modal />
    </main>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

import FooterApp from "@/components/layout/FooterApp.vue";
import PlanUpgradeHost from "@/components/layout/PlanUpgradeHost.vue";
import LegalAcceptanceModal from "@/components/legal/LegalAcceptanceModal.vue";

export default {
    name: "LayoutApp",
    components: {
        FooterApp,
        LegalAcceptanceModal,
        PlanUpgradeHost
    },
    computed: {
        ...mapState("auth", [
            "accessToken",
            "needOnboardingTenant",
            "permissions",
            "sessionCoreLoaded"
        ]),
        ...mapGetters("onboarding", ["routeForStep"])
    },
    created() {
        this.APPLY_SIDEBAR_ITEMS(this.permissions);
        this.$watch(
            () => this.$route,
            () => {
                document
                    .getElementById("app-container")
                    .scrollIntoView({ behavior: "smooth" });
            },
            {
                deep: true
            }
        );
    },
    async mounted() {
        this.completeSessionIfNeeded();

        if (!this.needOnboardingTenant) return;
        try {
            const data = await this.getOnboardingStatus();
            const flow = data.onboardingFlow;
            if (!flow || flow.status === "completed") return;

            // Sin diálogo ni opción de posponer: el onboarding incompleto no
            // es negociable, así que /app redirige de inmediato al step
            // pendiente en vez de dejar al usuario decidir si sigue en /app.
            const route = this.routeForStep(flow.step);
            if (route) {
                this.$router.push(route);
            }
        } catch {
            // Status endpoint not available
        }
    },
    methods: {
        ...mapMutations("control", ["APPLY_SIDEBAR_ITEMS"]),
        ...mapActions("onboarding", ["getOnboardingStatus"]),
        ...mapActions("auth", ["getProfile"]),
        // Mismo criterio que layouts/app.vue.
        async completeSessionIfNeeded() {
            if (!this.accessToken || this.sessionCoreLoaded) return;
            try {
                await this.getProfile();
            } catch {
                // Sin núcleo: se reintenta en la siguiente carga
            }
        }
    }
};
</script>
